import './app.css';
import { Provider } from 'react-redux';
import { history, store } from '@/store';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/instance';
import { ForceAuthentication } from './auth/forceauthentication';
import { HistoryRouter as Router } from 'redux-first-history/rr6';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { themes } from '@/theme';
import { InitProvider } from './initprovider';
import { RootLayout, AppRoutes } from './views/layout';
import {
	DialogManager,
	MessageManager,
	ProgressManager
} from './components/messaging';

export const App = () => {
	return (
		<Provider store={store}>
			<MsalProvider instance={msalInstance}>
				<ForceAuthentication>
					<Router history={history}>
						<ThemeProvider theme={themes.lightTheme}>
							<CssBaseline />
							<InitProvider>
								<RootLayout>
									<AppRoutes />
									<DialogManager />
									<MessageManager />
									<ProgressManager />
								</RootLayout>
							</InitProvider>
						</ThemeProvider>
					</Router>
				</ForceAuthentication>
			</MsalProvider>
		</Provider>
	);
};

export default App;
